var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-grid"},[_c('div',{staticClass:"p-col-12"},[_c('div',{staticClass:"card followup-page"},[_c('h4',[_vm._v("Follow up")]),_c('TabMenu',{attrs:{"id":"followUpTabs","model":_vm.tabs}}),_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }